<template>
  <div class="back-contianer" :class="noBorder ? 'back-contianer-reset' : ''">
    <i class="el-icon-arrow-left elm-icon" @click="handleGotoBack">返回</i>
  </div>
</template>

<script>
export default {
  name: 'back',
  props: {
    url: {
      type: String,
      default: ''
    },
    noBorder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    handleGotoBack() {
      if (!this.url) {
        // 返回上一页
        this.$router.go(-1)
        return
      }
      this.$emit('back')
      this.$router.push(this.url)
    },
    // 保存后关闭页面 父组件调用
    parentSave() {
      // 详情页 关闭页面并返回到详情页对应的 主页面
      let path = this.$route.path
      let mainTabs = this.$store.state.common.mainTabs
      let arr = mainTabs.filter((e) => e.path !== path)
      let str = this.url.slice(1)
      if (arr.length > 0) {
        this.$store.commit('common/updateMainTabs', arr)
        this.$router.push({ name: str })
        this.$store.commit('common/updateMainTabsActiveName', str)
      }else{
        this.$store.commit('common/updateMainTabs', arr)
        this.$store.commit('common/updateMainTabsActiveName', str)
        this.$router.push(this.url)
      }
    }
  }
}
</script>

<style scoped lang="scss">
//返回按钮
.back-contianer {
  color: #02a1e9;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
  text-align: right;
}
.back-contianer-reset {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0px;
}
.elm-icon {
  padding: 10px;
}
</style>
